module.exports = __webpack_public_path__ + "img/icon_excel.137fe0ce.svg";